import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    locale: localStorage.getItem('locale') ? localStorage.getItem('locale') : 'en-US',
    // pc: !navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    width: document.documentElement.clientWidth
    // pc: document.documentElement.clientWidth >= 1200
  },
  mutations: {
    setLocale (state, locale) {
      state.locale = locale
    },
    setWidth (state, width) {
      state.width = width
    }
  },
  getters: {
    locale: state => state.locale,
    isEn: state => state.locale === 'en-US',
    pc: state => state.width >= 1200
  }
})
